import { Getter } from "vuex";
import { IState, IFilterValue } from './state';

import qs from 'query-string';

const openFilterName: Getter<IState, IState> = (state) => {
	return Object.keys(state.filters).find(filterName => (state.filters[filterName] as any).open ? true : false)
};

const activeTags: Getter<IState, IState> = state => {
	return state.filters.tags.values
		.filter(value => value.selected)
}

const activeDates: Getter<IState, IState> = state => {
	return state.filters.dates.values
		.reduce((selectedMonths, date) => selectedMonths.concat(date.months.filter(month => month.selected)), [] as IFilterValue[]);
}

const searchUrl: Getter<IState, IState> = state => (tags: IFilterValue[], dates: IFilterValue[]) => {

	const page = state.pagination.current;
	const urlBase = state.searchUrl;

	return `${urlBase}&${qs.stringify({
		page,
		tags: tags.map(t => t.value).join(','),
		dates: dates.map(t => t.value).join(',')
	})}`
}

export default {
	openFilterName,
	searchUrl,
	activeDates,
	activeTags
}
